import { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { useFieldContext } from './FieldContext';
import { useHistory } from 'react-router-dom';

/**
 * @param {Omit<React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & { size: string, submit: boolean, reset: boolean, noDisable: boolean, formInput: boolean, linkTo: string, outlined: boolean, formless: boolean, legacy: boolean, family: boolean, as: "button" | "a" } , "type" | "onClick"> & { onClick: (event: any) => void | Promise }} props
 */
export default function FormButton({ className = "", size, submit, reset, noDisable, disabled, onClick, formInput, linkTo, outlined, formless, legacy, family, as: As = "button", children, ...rest }) {
    const { reset: resetForm, formState: { isLoading, isSubmitting, disabled: formDisabled } } = formless ? { formState: {} } : useFormContext();
    const [clickLoading, setClickLoading] = useState(false);
    const context = useFieldContext();
    const history = useHistory();
    disabled ||= context.disabled || (formInput && formDisabled);
    children ??= submit ? "Submit" : reset ? "Reset" : "";

    async function onButtonClick(e) {
        setClickLoading(true);

        try {
            await onClick?.(e);

            if (linkTo) {
                history.push(linkTo);
            }
        } finally {
            setClickLoading(false);
        }

        if (reset) {
            resetForm();
        }
    }

    const showDisabled = (!noDisable && (isLoading || isSubmitting)) || disabled || clickLoading;
    let classes = "large-button";

    if (!legacy) {
        classes = `${outlined ? "border-2 border-(--bg-color) hover:border-(--bg-hover-color) bg-transparent hover:bg-(--accent-color) text-(--bg-color) hover:text-(--bg-hover-color)" : "border-none bg-(--bg-color) hover:bg-(--bg-hover-color) text-white"}
            rounded-md ${size ? size : family ? "text-lg" : ""} px-5 py-2 font-semibold transition-colors flex max-w-fit ${showDisabled ? "pointer-events-none" : ""}`;
    }

    return (
        <As
            style={{
                "--bg-color": `var(${showDisabled ? (family ? "--color-blue-300" : "--color-red-300") : (family ? "--color-blue-500" : "--color-red-600")})`,
                "--bg-hover-color": `var(${family ? "--color-blue-600" : "--color-red-800"})`,
                "--accent-color": `var(${family ? "--color-blue-100" : "--color-red-200"})`
            }}
            className={`${classes} ${className}`}
            type={submit ? "submit" : reset ? "reset" : "button"}
            disabled={showDisabled} onClick={onButtonClick} {...rest}
        >
            {(submit && isSubmitting) || clickLoading ? <Spinner animation="border" as="span" className={legacy ? "" : "w-6! h-6! aspect-square border-[0.22rem]"} /> : children}
        </As>
    );
}